'use client'

import {ActivityArea} from '@/types/box/ActivityArea'
import {PifflBox} from '@/types/box/PifflBox'
import dynamic from 'next/dynamic'
import React from 'react'

const MapWithSearch = dynamic(() => import('@/components/MapWithSearch'), {
  ssr: false,
})

interface Props {
  boxes: PifflBox[]
  activityAreas: ActivityArea[]
}

export const MapWithSearchWrapper: React.FC<Props> = ({boxes, activityAreas}) => {
  return <MapWithSearch boxes={boxes} activityAreas={activityAreas} />
}
